import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  ViewChild,
} from '@angular/core';
import { FormGroup } from '@angular/forms';
import { MatAccordion } from '@angular/material/expansion';
import { UserService } from 'src/app/core/services/user.service';
import { UnitsService } from '../../../../core/services/units.service';
@Component({
  selector: 'app-text-search-filter',
  templateUrl: './text-search-filter.component.html',
  styleUrls: ['./text-search-filter.component.scss'],
})
export class TextSearchFilterComponent implements OnInit {
  @ViewChild(MatAccordion) accordion: MatAccordion;
  @Input() form: FormGroup;
  @Output() formchange = new EventEmitter<FormGroup>();
  filters = [];
  data;
  constructor(
    private unitService: UnitsService,
    private userService: UserService
  ) {}
  ngOnInit() {
    this.getUnitType();
  }

  allComplete: boolean = false;

  getUnitType() {
    let units = this.userService.currentUser?.role.units;
    this.unitService.getUnitAndCaseType(units).subscribe((res) => {
      this.data = res;
    });
  }
  updateAllComplete(i, j) {
    // this.allComplete = this.task.subtasks != null && this.task.subtasks.every(t => t.completed);
  }

  selectOption(option: string) {
    let position = this.filters.indexOf(option);
    if (position != -1) {
      this.filters.splice(position, 1);
    } else {
      this.filters.push(option);
    }
    this.form.controls.filters.setValue(this.filters);
    // this.form.value.filters = this.filters;
    this.formchange.emit(this.form);
  }
  someComplete(i: number): boolean {
    return true;
    // if (this.task.subtasks == null) {
    //   return false;
    // }
    // return this.task.subtasks.filter(t => t.tipo_caso).length > 0 && !this.allComplete;
  }
  setAll(completed: boolean, i: number) {
    // this.allComplete = completed;
    if (this.data[i].tipo_caso == null) {
      return;
    }
    this.data[i].tipo_caso.forEach((t) => (t.checked = completed));
  }
}
